import { render, staticRenderFns } from "./sip-badge-state.vue?vue&type=template&id=565f6a88&"
import script from "./sip-badge-state.vue?vue&type=script&lang=js&"
export * from "./sip-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports